import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import URI from "URI/URI";
import utils from "ulysses/widgets/search/utils";
import SearchSelection from "ulysses/widgets/search/search_selection";
import FacetHelper from "ulysses/widgets/search/search_facets";
import SearchQuery from "ulysses/widgets/search/search_query";
import SearchItem from "ulysses/widgets/search/search_item";
import "ulysses/widgets/search/search_actions";
import "ulysses/widgets";
import "ulysses/controls/scroller";
import "ulysses/widgets/search/search_grid";
import "jquery-libs/knob";

"use strict";


function build_search_model(settings_obs, parameters_obs, context, search_id) {
    var search_model = null;
    search_model = {
        search_placeholder: ko.observable(ko.unwrap(settings_obs).search_placeholder || _('search_search_placeholder', 'Search Ulysses')),
        pager: {
            "prev": ko.observable(),
            "next": ko.observable(),
            "total": ko.observable(0),
            "start_index": ko.observable(0),
            "page_size": ko.observable(uly.settings.solr_page_size),
            "tot_page": ko.observable(0),
            "search_actions": ko.observableArray(),
            "panel_visible": ko.observable(ko.unwrap(settings_obs).facets_visible === true),
            "show_controls": ko.observable(ko.unwrap(settings_obs).show_controls !== false),
            "selection_aware": ko.observable(ko.unwrap(settings_obs).selection_aware !== false),
            "actions_visible": ko.observable(ko.unwrap(settings_obs).actions_visible !== false),
            "parameter_names": ko.pureComputed(function () {
                return ko.unwrap(settings_obs).parameter_names || ko.unwrap(parameters_obs).parameter_names;
            }),
            "parametrised_filters": ko.pureComputed(function () {
                return ko.unwrap(settings_obs).parametrised_filters || ko.unwrap(parameters_obs).parametrised_filters;
            }),
            "panel_markup": ko.pureComputed(function () {
                return ko.unwrap(settings_obs).panel_markup || ko.unwrap(parameters_obs).panel_markup;
            }),
            "parameter_values": ko.observable({}),
            "toggle_panel": function () {
                search_model.pager.panel_visible(!search_model.pager.panel_visible());
                if (search_model.pager.panel_visible()) {
                    search_model.query_results();
                }
            },
            "sortables": ko.observableArray([{
                "caption": _("search_caption_last_update", "Last Update"),
                "field": "significant_date"
            }, {
                "caption": _("search_caption_title", "Title"),
                "field": "title_t"
            }]),
            "saved_filters": ko.observableArray([]),
            "facet_sets": ko.observableArray([]),
            "sort_col": ko.pureComputed(function () {
                var csort = ko.unwrap(settings_obs).search_sort || "-significant_date";
                return csort.substring(1);
            }),
            "sort_dir": ko.pureComputed(function () {
                var csort = ko.unwrap(settings_obs).search_sort || "-significant_date";
                return csort[0] === "-" ? "desc" : "asc";
            }),
            "search_sort": ko.pureComputed(function () {
                return ko.unwrap(settings_obs).search_sort || "-significant_date";
            }),
            "display_mode": ko.pureComputed(function () {
                return ko.unwrap(settings_obs).display_mode || "list"
            }),
            "set_sort": function (sort) {
                var settings = ko.unwrap(settings_obs);
                if (sort != settings.search_sort) {
                    settings.search_sort = sort;
                    settings_obs(settings);
                    uly.publish("page.savesettings");
                    console.error("set sort");
                    search_model.pager.start_index(0);
                }
                return search_model.query_results();
            },
            "sort": function (ui, ev) {
                var col = ko.unwrap(ui.field);
                var sort = null;
                if (col != search_model.pager.sort_col()) {
                    sort = "+" + col;
                } else {
                    sort = (search_model.pager.sort_dir() === "asc" ? "-" : "+") + col;
                }
                return search_model.pager.set_sort(sort);
            },
            "load_filter": function (ui, ev) {
                search_model.current_filter(ui);
                search_model.set_search_configuration(ui.configuration);
                search_model.query_results();
            },
            "load_facet_set": function(ui, ev) {
                let fs = ui.name;
                //uly.api.start().follow("uly:search").follow("uly:facets", { "name": fs}).then((result)  => {
                    search_model.faceting.clearFacets();
                    search_model.current_facet_set(fs);
                    search_model.pager.panel_visible(true);
                    //search_model.pager.set_search_configuration(ui.configuration);
                    search_model.query_results();
                //});
            },
            "set_display_mode": function (ui, ev) {
                var mode = $(ev.currentTarget).data("mode") || 'list';
                var settings = settings_obs();
                settings.display_mode = mode;
                settings_obs(settings);
                uly.publish("page.savesettings");
                return search_model.query_results();
            },
            "go_prev": function () {
                var next_val = search_model.pager.start_index() - search_model.pager.page_size();
                if (next_val < 0)
                    next_val = 0;
                if (next_val != search_model.pager.start_index())
                    search_model.pager.start_index(next_val);
                return search_model.query_results();
            },
            "go_next": function () {
                var next_val = search_model.pager.start_index() + search_model.pager.page_size();
                if (next_val > search_model.pager.total())
                    return null;
                if (next_val < 0)
                    next_val = 0;
                if (next_val != search_model.pager.start_index())
                    search_model.pager.start_index(next_val);
                return search_model.query_results();
            },
            "go_to": function (index) {
                search_model.pager.start_index(index);
                return search_model.query_results();
            },
            "show_selection": function () {
                search_model.parameters._search_body("is:selected");
                return search_model.query_results();
            },
            "clear_selection": function () {
                search_model.pager.selection.clear();
            },
            "select_all": function () {
                var query = SearchQuery.computeSearchQuery(search_model, ko.unwrap(settings_obs), context);
                search_model.pager.selection.select_all(search_model.results, query);
            },
            "select_page": function () {
                search_model.pager.selection.select_all_on_page(search_model.results);
            }
        },
        table: {
            "columns": ko.pureComputed(function () {
                return ko.unwrap(settings_obs).columns || [{
                    "field": "title_t",
                    "caption": _("search_caption_title", "Title")
                }];
            }),
            "set_column_ordering": function setColumnOrdering(new_ordering) {
                var settings = ko.unwrap(settings_obs);
                var columns = settings.columns || ["title"];
                settings.columns = new_ordering.map(function (old_idx) {
                    if (old_idx >= 0)
                        return columns[old_idx];
                });
                settings_obs(settings);
                uly.publish("page.savesettings");
            }
        },
        callback: ko.observable(function () {
            console.error("scroller wtf:", arguments, arguments[0]);
        }),
        results: ko.observableArray([]),
        clear_results: function () {
            var vals = this.results();
            vals.forEach((item) => {
                item._dispose();
            });
            vals = null;
            this.results([]);
        },
        result_template: ko.observable('search-result-tmp'),
        hardcoded_model: ko.observable(ko.unwrap(ko.unwrap(settings_obs).hardcoded_model)),
        parameters: {
            _search_body: ko.observable(null)
        },
        result_title: ko.observable(null), //title that comes back from results.
        error: ko.observable(null),
        trigger: ko.observable(0),
        external: ko.observable(false),
        in_popup: ko.observable(false),
        multiselect: ko.observable(false),
        current_filter: ko.observable(null),
        current_export: ko.observable(null),
        current_facet_set: ko.observable(null),
        busy: ko.observable(false),
        dynamic_faceting: ko.observable(true),
        last_query_timing: ko.observable(null),
        last_query_full: ko.observable(null),
        activate_entity: function (item, ev) {
            if (item.unique_id) {
                var ev_tag = ev.target.tagName.toLowerCase();
                if (ev_tag == "span") {
                    //if the span is in a link, don't activate
                    if ($(ev.target).parent()[0].tagName.toLowerCase() == "a")
                        return true;
                }
                if (["a", "button", "input", "summary"].indexOf(ev_tag) < 0)
                    uly.publish("page.activate.entity", item.unique_id);
                else return true;
            }
        },
        handleSearchKey: (ui, e) => {
            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                let val = $(e.target).val();
                search_model.parameters._search_body(val);
            }
            return true;
        },
        control_id: search_id
    };
    search_model.faceting = new FacetHelper(search_model, settings_obs, context);
    search_model.pager.selection = new SearchSelection(search_model.results);

    search_model.pager.need_pager = ko.pureComputed(function () {
        return search_model.pager.total() > search_model.pager.page_size();
    });
    search_model.pager.pager_pages = ko.pureComputed(function () {
        var res = [];
        var page_size = search_model.pager.page_size() || 10;
        var tot_pages = Math.floor(search_model.pager.total() / page_size) + 1;
        var cindex = search_model.pager.start_index();
        var cpage = Math.floor(cindex / page_size);

        res.push([1, cindex > 0 ? 0 : "."]);
        if (cpage > 2)
            res.push(["...", "."]);
        if (cpage > 1)
            res.push([cpage, (cpage - 1) * page_size]);
        if (cpage > 0 && cpage < tot_pages - 1)
            res.push([cpage + 1, "."]);
        if (cpage < tot_pages - 2)
            res.push([cpage + 2, (cpage + 1) * page_size]);
        if (cpage < (tot_pages - 3))
            res.push(["...", "."]);
        res.push([tot_pages, cpage < tot_pages - 1 ? (tot_pages - 1) * page_size : "."]);
        return res;
    });

    search_model.pager.pager_summary = ko.pureComputed(function () {
        var tot_pages = search_model.pager.tot_page();
        var start_index = parseInt(search_model.pager.start_index(), 10) + 1;
        var page_size = parseInt(search_model.pager.page_size(), 10);
        var total = search_model.pager.total();

        if (tot_pages > 0) {
            if (total < start_index + page_size) {
                return _("search_pager_summary_with_pages", "{0} to {1} of {2}").format(start_index, total, total);
            } else {
                return _("search_pager_summary_with_pages", "{0} to {1} of {2}").format(start_index, start_index + page_size - 1, total);
            }
        } else if (total > 0) {
            return _("search_pager_summary_no_pages", "{0} of {0}").format(total);
        } else {
            return _("search_pager_summary_no_data", "no results found");
        }

    });
    search_model.title = ko.pureComputed(function () {
        var title = search_model && ko.unwrap(search_model.settings) && ko.unwrap(ko.unwrap(search_model.settings).title);
        if (title) return title;
        title = search_model && ko.unwrap(search_model.result_title);
        return title || ko.unwrap(_("search_build_search_model_search", "Search"));
    });

    search_model.pager.parameter_names.subscribe(function (newvalue) {
        //updates parameter values
        if (newvalue) {
            var pvalues = {};
            var currentVals = ko.unwrap(search_model.pager.parameter_values) || {};
            var pnames = newvalue.split(",");
            $.each(pnames, function (idx, val) {
                pvalues[val] = ko.observable(ko.unwrap(currentVals[val]));
            });
            search_model.pager.parameter_values(pvalues);
        } else {
            search_model.pager.parameter_values({});
        }
    });
    search_model.pager.rendered_filter = ko.pureComputed(function () {
        var f = ko.unwrap(search_model.pager.parametrised_filters);
        if (!f)
            return null;
        var values = ko.toJS(ko.unwrap(search_model.pager.parameter_values));
        var pnames = ko.unwrap(search_model.pager.parameter_names);
        if (!pnames)
            return f;
        var vals = $.map(pnames.split(","), function (val, idx) {
            return values[val] || "";
        });
        return f.format(vals);
    });

    var settings = ko.unwrap(settings_obs);
    if (settings.parameters) {
        if (settings.parameters._search_body) {
            search_model.parameters._search_body(ko.unwrap(settings.parameters._search_body));
        }
        $.extend(search_model.parameters, settings.parameters, {
            _search_body: search_model.parameters._search_body
        });
    }


    search_model.query_results = function () {
        var model = this;
        this.busy(true);
        var def = uly.utils.throttle(model, function () {
            var result = SearchQuery.executeSearchQuery(model, ko.unwrap(settings_obs), context);
            return result;
        }, 250);
        return def.then(function (func_deferred) {
            return func_deferred;
        });
    };

    search_model.query_params = ko.pureComputed(function () {
        var search_settings = ko.unwrap(settings_obs);
        return SearchQuery.computeSearchParameters(search_model, settings_obs, context);
    });

    search_model.page_to = function (start_index, page_size) {
        this.pager.start_index(start_index || 0);
        if (page_size && page_size > 0) {
            this.pager.page_size(page_size);
        }
        return this.query_results();
    };

    search_model.callback(function (after) {
        var start_index = ko.unwrap(search_model.pager.start_index);
        var page_size = ko.unwrap(search_model.pager.page_size);
        if (ko.unwrap(search_model.pager.total) > start_index + page_size) {
            search_model.pager.start_index(start_index + page_size);
            search_model.query_results();
            search_model.external(true);
        }
    });

    search_model.full_parameters = ko.pureComputed(function () {
        return {
            p: ko.toJS(search_model.parameters),
            pv: ko.toJS(search_model.pager.parameter_values)
        };
    });

    search_model.full_parameters.subscribe(function () {
        search_model.pager.start_index(0);
        search_model.query_results();
    });

    search_model.get_search_configuration = function () {
        var local_params = search_model.query_params();
        var search_filter = ko.unwrap(ko.unwrap(settings_obs).filter);
        var filter_data = {
            "parameters": ko.toJS(search_model.parameters),
            "faceting": {
                "active": ko.toJS(search_model.faceting.active),
                "custom": ko.toJS(search_model.faceting.custom)
            },
            "search_sort": search_model.pager.search_sort(),
            "search_query": local_params
        };
        if (search_filter) {
            filter_data.filter = search_filter;
        }

        if (local_params.q && local_params.q._type) {
            filter_data._type = local_params.q._type;
        }
        return filter_data;
    };
    search_model.set_search_configuration = function (configuration, ignore_facets) {
        var configuration = ko.toJS(configuration);
        if (configuration.faceting) {
            search_model.faceting.active(configuration.faceting.active);
            if (ignore_facets !== true)
                search_model.faceting.custom(configuration.faceting.custom);
        } else {
            search_model.faceting.active([]);
            if (ignore_facets !== true)
                search_model.faceting.custom([]);
        }
        if (configuration.filter) {
            ko.unwrap(settings_obs).filter = configuration.filter;
        }
        Object.keys(configuration.parameters || []).forEach(function (key) {
            if (ko.isObservable(search_model.parameters[key])) {
                search_model.parameters[key](configuration.parameters[key]);
            }
        });
    };
    search_model.pager.has_more_facet_sets = ko.pureComputed(()=>{
        return search_model.pager.facet_sets().filter((f) => { return f.name != "default"; }).length > 0;
    });

    return search_model;
}

function build_parameter_panel_data(parameters_obs, settings, context) {
    /*
     If we don't have parameter panel data, check if we can fetch it.
     */
    var def = Promise.Deferred();
    if (!settings.panel_markup && !settings.parameter_names && !settings.parametrised_filters) {
        var type = null;
        if (ko.unwrap(settings.filter)) {
            var type_re = /type:[a-zA-Z0-9_]+/g;
            var types = ko.unwrap(settings.filter).match(type_re);
            if (types && types.length == 1) {
                type = types[0].slice(5);
            }
        }
        if (!type) {
            type = utils.get_contextual_collection_type(context);
        }
        if (type) {
            uly.api.start().follow("uly:models").follow("find", {
                "rel": type
            }).done(function (result) {
                def.resolve(result.search_panel);
            }).fail(function () {
                def.resolve(null);
            });
        } else {
            def.resolve(null);
        }
    } else {
        def.resolve(null);
    }
    return def.then(function (result) {
        if (result) {
            parameters_obs(result);
        } else {
            parameters_obs({});
        }
    });
}


uly.utils = $.extend(uly.utils, {
    filter_search_by_page: SearchQuery.filterSearchByPage
});

function populate_parameters(settings, parameters, state, param_values, search_model) {
    var def = Promise.Deferred();
    var navigable = ko.unwrap(settings.navigable);
    if (navigable === null || typeof navigable == "undefined")
        navigable = true;
    if (navigable) {
        var filter = "";
        if (state) {
            if (state.query_data && state.query_data.filters)
                filter = state.query_data.filters;
            else if (state.filters)
                filter = state.filters;
            if (!parameters._search_body || !ko.isObservable(parameters._search_body)) {
                parameters._search_body = ko.observable(null);
            }
            if (!ko.unwrap(parameters._search_body)) {
                parameters._search_body(filter);
            }
            if (param_values) {
                param_values = ko.unwrap(param_values);
                $.each(param_values, function (key, value) {
                    console.log("key:", key, "value:", value);
                    if (key && state.query_data && state.query_data[key]) {
                        if (ko.isObservable(value)) {
                            value(state.query_data[key]);
                        } else {
                            param_values[key] = state.query_data[key];
                        }
                    } else if (key && state[key]) {
                        if (ko.isObservable(value)) {
                            value(state[key]);
                        } else {
                            param_values[key] = state[key];
                        }
                    }
                });
            }
            var sf = (state.query_data && state.query_data.sf) || state.sf;
            if (sf) {
                uly.api.start().follow("uly:search").follow("find", {"name": sf}).then((res)=> {
                    console.log("got filter: ", res);
                    if (res.configuration) {
                        search_model._config = res.configuration;
                        search_model.set_search_configuration(search_model._config);
                    }
                    def.resolve(true);
                }, (error)=> {
                    console.error("Error fetching filter ", sf, error);
                    def.resolve(false);
                })
            } else {
                def.resolve(true);
            }
            var fs = (state.query_data && state.query_data.fs) || state.fs;
            if (fs) {
                search_model.current_facet_set(fs)
            }
        }
    } else {
        def.resolve(true);
    }
    return def.promise();
}

function update_url_parameters(settings, parameters, query, param_values) {
    var navigable = ko.unwrap(settings.navigable);
    if (navigable === null || typeof navigable == "undefined")
        navigable = true;

    if (!navigable)
        return;
    var filter_value = query._search_body;
    var state = uly.history.get_parsed_state();
    var query_data = state.query_data || {};
    var is_modified = false;
    if (!(filter_value == query_data.filters || (!filter_value && !query_data.filters))) {
        is_modified = true;
        query_data.filters = filter_value;
    }

    if (param_values) {
        $.each(param_values, function (key, value) {
            var v = ko.unwrap(value);
            if (v && key && (query_data[key] != v && (query_data[key] || v))) {
                is_modified = true;
                query_data[key] = v;
            }
        });
    }

    if (!is_modified)
        return;

    var uri = new URI(state.hash);
    uri.removeQuery("_suid");
    delete(query_data._suid);

    uri.setQuery(query_data);
    var hash = uri.toString();
    uly.publish("history.replacestate", uly.history.get_temporary_state(hash));
}

var search_idx = 0;

ko.bindingHandlers.search = {
    "init": function (elt, va, bindings, model, context) {

        var search_template = bindings().search_template;
        var my_search_id = "search_" + search_idx++;
        $(elt).attr("id", my_search_id);
        var widget_id = ko.unwrap(bindings().widget_id);

        var settings = ko.unwrap(va());
        var parameters_obs = ko.observable({});
        var search_model = build_search_model(va(), parameters_obs, context, my_search_id);
        search_model.result_template(ko.unwrap(bindings().result_template) || "search-result-tmp");

        //setup subscription for listening to data changes
        var previous_data = null;
        var previous_relation = null;
        var previous_token = null;

        var search_result_changed = function () {
            search_model.query_results();
        };

        //TODO: mahogany gas pipes
        var _special_token = null;
        var _special_id = null;

        var _sub = search_model.results.subscribe(function (newresults) {
            var ids = [];
            for (var i = 0; i < newresults.length; ++i) {
                ids.push(newresults[i].unique_id);
            }
            if (_special_token && _special_id && ids.indexOf(_special_id) >= 0) {
                uly.unsubscribeToChange(_special_id, _special_token);
                _special_token = null;
                _special_id = null;
            }
            previous_data = uly.bulkSubscribeToChange(ids, previous_data, search_result_changed, elt);
            var rel = utils.get_contextual_relation(ko.unwrap(va()), context);
            if (rel != previous_relation) {
                if (previous_token) {
                    previous_token.unsubscribe();
                    previous_token = null;
                }
                if (rel)
                    previous_token = uly.subscribeToRelatedChange(rel, search_result_changed, elt);
            }
            previous_relation = rel;
            search_model.callback.valueHasMutated();
        });


        var _create_sub = uly.subscribe("entity.created." + my_search_id, function (topic, payload) {
            console.error(arguments);
            search_result_changed();
            if (payload && payload.unique_id) {
                _special_id = payload.unique_id;
                _special_token = uly.subscribeToChange(_special_id, search_result_changed, elt);
            }
        });



        ko.utils.domNodeDisposal.addDisposeCallback(elt, function () {
            uly.unsubscribe(_create_sub);
            _create_sub = null;
            _sub.dispose();
            // cleanup items
            search_model.clear_results();
        });

        if (widget_id) {
            uly.subscribe("page.save_state", function (topic, state) {
                state.data[widget_id] = {
                    "start": search_model.pager.start_index(),
                    "sb": search_model.parameters._search_body(),
                    "facets": search_model.faceting.active(),
                    "panel_visible": search_model.pager.panel_visible()
                };
            }, $(elt));

            var resource = ko.unwrap(uly.page.page_resource);
            console.log("uly.page resource: ", resource);
            if (resource && resource.search_meta && ko.unwrap(settings.use_screen_configuration)) {
                search_model.set_search_configuration(ko.unwrap(resource.search_meta), true);
            }
        }

        var widget_title = bindings().title;
        if (ko.isObservable(widget_title)) {
            search_model.title.subscribe(function (newvalue) {
                widget_title("{0}".format(newvalue));
            });
        }

        var widget_subtitle = bindings().subtitle;
        if (ko.isObservable(widget_subtitle)) {
            search_model.pager.total.subscribe(function (newvalue) {
                widget_subtitle(newvalue);
            });
        }

        $(elt).data("search_model", search_model);

        //prevent extra searching for now.
        $(elt).data("search-updating", true);

        var state = uly.history.get_parsed_state().query_data;
        build_parameter_panel_data(parameters_obs, settings, context).always(function () {
            // search_model.pager.parameter_names.notifySubscribers(search_model.pager.parameter_names());
            populate_parameters(settings, search_model.parameters, state, search_model.pager.parameter_values, search_model).then(()=>{
                if (widget_id) {
                    //now recall stored state
                    var page_state = uly.history.get_state();
                    var search_state = page_state.data[widget_id];
                    if (search_state) {
                        if (search_state.start) {
                            search_model.pager.start_index(search_state.start);
                        }
                        if (search_state.sb) {
                            search_model.parameters._search_body(search_state.sb);
                        }
                        if (search_state.facets) {
                            search_model.faceting.active(search_state.facets);
                        }
                        if (search_state.panel_visible) {
                            search_model.pager.panel_visible(search_state.panel_visible);
                        }
                    }
                }
                //Now we're ready to rock.
                $(elt).data("search-updating", false);
                //force search
                search_model.query_results();
            });
        });
        var childContext = context.createChildContext(search_model);
        childContext.search_template = search_template;
        $(elt).html("<!-- ko template:search_template --><!-- /ko -->");
        if (widget_id) {
            //now recall stored state
            var page_state = uly.history.get_state();
            var search_state = page_state.data[widget_id];
            if (search_state && search_model) {
                if (search_state.start) {
                    search_model.pager.start_index(search_state.start);
                }
                if (search_state.sb) {
                    search_model.parameters._search_body(search_state.sb);
                }
                if (search_state.facets) {
                    search_model.faceting.active(search_state.facets);
                }
                if (search_state.panel_visible) {
                    search_model.pager.panel_visible(search_state.panel_visible);
                }
            }
        }

        ko.applyBindingsToDescendants(childContext, elt);
        return {
            controlsDescendantBindings: true
        };
    },
    "update": function (elt, va) {
        var search_model = $(elt).data("search_model");
        var search_settings = ko.unwrap(va());
        var query = ko.toJS(search_model.parameters) || {};

        if ($(elt).data("search-updating"))
            return;

        update_url_parameters(search_settings, search_model.parameters, query, ko.unwrap(search_model.pager.parameter_values));
    }
};



//hack for now. remove me.
uly.page.searchify_item = SearchItem.searchify_item;

ko.bindingHandlers.myvalue = {
    init: function (elt, va, allbindings, model, context) {
        console.log("myvalue:", va(), va()(), elt);
        return ko.bindingHandlers.value.init(elt, va, allbindings, model, context);
    },
    update: function (elt, va, allbindings, model, context) {
        console.log("myvalue upd:", va(), va()(), elt);
        return ko.bindingHandlers.value.update(elt, va, allbindings, model, context);
    }
};

ko.bindingHandlers.searchpopup = {
    init: function (elt, va, allbindings, model, context) {
        var search_options = ko.unwrap(va()) || {};
        var inherit_parent_field = search_options.inherit_parent_field;
        var inherit_path = search_options.inherit_path;

        var search_settings = $.extend({
            navigable: false,
            contextual: false,
            inherit_path: ko.unwrap(inherit_path),
            inherit_parent_field: ko.unwrap(inherit_parent_field),
            in_search_popup: true
        }, search_options);
        var multiple = ko.unwrap(search_settings.multiple);
        var selection = ko.observableArray([]);
        $(elt).on("action:selectresult", function (ev, ui) {
            console.log("got selection:", ev, ui);
            if (!multiple) {
                //close the dialog
                var entity = ui.model;
                va().selection = entity;
                $(elt).trigger("action:closedialog", ui);

            }
        });
        var childContext = context.createChildContext(search_settings);
        ko.applyBindingsToDescendants(childContext, elt);
        return {
            "controlsDescendantBindings": true
        };

    }
};
ko.bindingHandlers.knob = {
    init: function (elt) {

        $(elt).knob({
            readOnly: true
        });
    }
};

ko.bindingHandlers.actionmenu = {
    init: function (elt, va, allbindings, model, context) {
        var menu_shown = ko.observable(false);
        $(elt).on("show.bs.dropdown", function () {
            menu_shown(true);
        });

        var childContext = context.extend({
            "menu_shown": menu_shown
        });
        ko.applyBindingsToDescendants(childContext, elt);
        return {
            "controlsDescendantBindings": true
        };
    }
};

ko.bindingHandlers.ulyev = {
    init: function (elt, va) {
        var handlers = ko.unwrap(va());
        if (handlers) {
            Object.keys(handlers).forEach(function (key) {
                if (handlers[key])
                    $(elt).on(key, handlers[key]);

            });
        }
    }
};

ko.bindingHandlers.custom_search = {
    "init": function (elt, va, allbindings, model, context) {
        var custom_model = {
            "search_settings": ko.observable({
                "navigable": false,
                "contextual": false,
                "filter": null,
                "parameters": {
                    _search_body: null
                }
            }),
            "search_active": ko.observable(false),
            "search": function (body, filters) {
                this.search_settings(utils.ensure_settings_complete({
                    "filter": filters,
                    "parameters": {
                        "_search_body": body
                    }
                })[0]);
                this.search_active(false);
                this.search_active(true);
            }
        }
        var child = context.createChildContext(custom_model);
        ko.applyBindingsToDescendants(child, elt);
        return {
            controlsDescendantBindings: true
        };
    }
}